import Vue from "vue";

import { Snackbar } from "./types";

export const SnackbarState = Vue.observable({
  resolve: Object as (value?: any) => void,
  timeout: 0,
  show: false,
  message: "",
  buttons: [] as Array<{ label: string; value: string }>,
  _timeout: 0,
  options: undefined as { error?: boolean } | undefined,
});

export const snackbar: Snackbar = {
  show(
    message: string,
    timeout = 0,
    buttons: Array<{ label: string; value: string }> = [],
    options?: { error?: boolean }
  ): Promise<any> {
    return new Promise(res => {
      SnackbarState.message = message;
      SnackbarState.buttons = buttons;
      SnackbarState.timeout = timeout;
      SnackbarState.resolve = res;
      SnackbarState.show = true;
      SnackbarState.options = options;

      if (timeout) {
        SnackbarState._timeout = setTimeout(() => {
          SnackbarState._timeout = 0;
          this.close("timeout");
        }, timeout) as any;
      }
    });
  },
  close(value: any) {
    if (SnackbarState.show) {
      if (SnackbarState._timeout) {
        clearTimeout(SnackbarState._timeout);
      }
      SnackbarState.resolve(value);
      SnackbarState.show = false;
    }
  },
};

Vue.use({
  install(/* vue, options = {} */) {
    Vue.prototype.$snackbar = snackbar;
  },
});
